import * as React from 'react';
import { trackSignupClicked } from '../../utils/tracking';
import { route } from '../../utils/route';

interface FinalCTAProps {
  onDownloadClick: () => void;
}

export function FinalCTA({ onDownloadClick }: FinalCTAProps) {
  return (
    <section className="wholesale-final-cta">
      <style>{`
        .wholesale-final-cta {
          padding: 80px 24px;
          background: #1a1a1a;
          text-align: center;
        }
        .wholesale-final-inner {
          max-width: 640px;
          margin: 0 auto;
        }
        .wholesale-final-cta h2 {
          font-size: 28px;
          font-weight: 800;
          color: #fff;
          margin: 0 0 12px;
        }
        .wholesale-final-cta p {
          font-size: 18px;
          color: rgba(255,255,255,0.75);
          margin: 0 0 36px;
        }
        .wholesale-final-ctas {
          display: flex;
          gap: 16px;
          justify-content: center;
          flex-wrap: wrap;
        }
        @media (max-width: 640px) {
          .wholesale-final-cta {
            padding: 60px 24px;
          }
          .wholesale-final-cta h2 {
            font-size: 24px;
          }
          .wholesale-final-ctas {
            flex-direction: column;
            align-items: stretch;
          }
          .wholesale-final-ctas a {
            justify-content: center;
          }
        }
      `}</style>
      <div className="wholesale-final-inner">
        <h2>Empezá a comprar con precios mayoristas hoy.</h2>
        <p>Creá tu cuenta, elegí tus productos y recibí en tu negocio.</p>
        <div className="wholesale-final-ctas">
          <a href={route('company.create')} className="wholesale-btn-primary" onClick={() => trackSignupClicked('precios-mayoristas', 'footer')}>
            <i className="fa fa-user-plus" /> Crear cuenta mayorista
          </a>
          <button onClick={onDownloadClick} className="wholesale-btn-secondary">
            <i className="fa fa-file-excel" /> Descargar lista de precios
          </button>
        </div>
      </div>
    </section>
  );
}
